
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-image-enhancer",
      function () {
        return require("private-next-pages/ai-image-enhancer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-image-enhancer"])
      });
    }
  